import { useCallback, useEffect, useState } from "react";
import {
  Box, Stack, Typography, Paper, Chip, Alert, CircularProgress, IconButton, Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { BRAND } from "../styles/theme";
import { getBindBalance } from "../services/bind";

function fmtMonto(n: number): string {
  return n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function BindSaldos() {
  const [saldo,   setSaldo]   = useState<number | null>(null);
  const [hasData, setHasData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);
  const [updatedAt, setUpdatedAt] = useState<Date | null>(null);

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const s = await getBindBalance();
      setSaldo(s); setHasData(true); setUpdatedAt(new Date());
    } catch (e) {
      setError(String(e instanceof Error ? e.message : e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>Bind · Saldos</Typography>
        <Tooltip title="Refrescar">
          <span><IconButton onClick={load} disabled={loading} size="small"><RefreshIcon /></IconButton></span>
        </Tooltip>
      </Stack>

      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}

      {loading && !hasData ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><CircularProgress /></Box>
      ) : (
        <Stack direction="row" flexWrap="wrap" gap={2}>
          <Paper sx={{ p: 2.5, borderRadius: 3, minWidth: 320, flex: "1 1 320px", maxWidth: 420 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography sx={{ fontWeight: 700 }}>Cuenta BindPSP</Typography>
              <Chip label="ARS" size="small"
                sx={{ fontWeight: 700, fontSize: 11, height: 22, color: BRAND.primary, bgcolor: BRAND.primaryLight }} />
            </Stack>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
              Saldo de la cuenta de cobranza BindPSP (vía BIND PSP).
            </Typography>

            <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Saldo disponible</Typography>
            <Typography sx={{ fontSize: 30, fontWeight: 800, color: BRAND.primary, lineHeight: 1.2 }}>
              {hasData && saldo != null ? `$ ${fmtMonto(saldo)}` : hasData ? "—" : ""}
            </Typography>
            {hasData && saldo == null && (
              <Typography variant="caption" color="text.secondary">
                El banco no devolvió saldo en este momento (reintentá con el ícono de refrescar).
              </Typography>
            )}

            {updatedAt && (
              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2 }}>
                Actualizado {updatedAt.toLocaleString("es-AR")}
              </Typography>
            )}
          </Paper>
        </Stack>
      )}
    </Box>
  );
}
